import { render, staticRenderFns } from "./TicketDetailView.vue?vue&type=template&id=e1652f28&scoped=true&"
import script from "./TicketDetailView.vue?vue&type=script&lang=js&"
export * from "./TicketDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1652f28",
  null
  
)

export default component.exports